import { Result } from 'domain/types';
import GetDashboardClient from 'use-case/dashboard/get/getDashboardClient';
import GetDashboardCriteria from 'use-case/dashboard/get/getDashboardCriteria';
import Dashboard from 'domain/entity/dashboard';

export type GetDashboardResult = Result<Dashboard>;
export type GetDashboard = (criteria: GetDashboardCriteria) => Promise<GetDashboardResult>;

export default (getDashboardClient: GetDashboardClient): GetDashboard => (criteria: GetDashboardCriteria): Promise<GetDashboardResult> =>
    getDashboardClient(criteria);
